<script setup>
import { ref, computed } from 'vue';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import ConversationApi from 'dashboard/api/inbox/conversation';

import Button from 'dashboard/components-next/button/Button.vue';

const getters = useStoreGetters();
const { t } = useI18n();

const isLoading = ref(false);

const currentChat = computed(() => getters.getSelectedChat.value);

const onMarkAsUnread = async () => {
  isLoading.value = true;
  try {
    await ConversationApi.markMessagesUnread({ id: currentChat.value.id });
    useAlert(t('CONVERSATION.MARK_AS_UNREAD_SUCCESS'));
    isLoading.value = false;
  } catch (error) {
    isLoading.value = false;
    useAlert(t('CONVERSATION.MARK_AS_UNREAD_FAILED'));
  }
};
</script>

<template>
  <div class="relative flex items-center justify-end resolve-actions">
    <div class="rounded-lg shadow outline-1 outline flex-shrink-0 outline-n-container">
      <Button
        :label="t('CONVERSATION.HEADER.MARK_AS_UNREAD')"
        size="sm"
        color="slate"
        :is-loading="isLoading"
        @click="onMarkAsUnread"
      />
    </div>
  </div>
</template>
